import React, {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import {useTranslation} from "react-i18next";

const Password = () => {
    const { t } = useTranslation();

    const [passwordShown, setPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

    const usePasswordValidation = ({ firstPassword = "", secondPassword = "" }) => {
        const [validMinLength, setValidMinLength] = useState(null);
        const [validMaxLength, setValidMaxLength] = useState(null);
        const [upperCase, setUpperCase] = useState(null);
        const [lowerCase, setLowerCase] = useState(null);
        const [specialChar, setSpecialChar] = useState(null);
        const [hasNumber, setHasNumber] = useState(null);
        const [match, setMatch] = useState(null);

        useEffect(() => {
            setValidMinLength(firstPassword.length >= 8 ? true : false);
            setValidMaxLength(firstPassword.length < 100 ? true : false);
            setUpperCase(firstPassword.toLowerCase() !== firstPassword);
            setLowerCase(firstPassword.toUpperCase() !== firstPassword);
            setHasNumber(/\d/.test(firstPassword));
            setSpecialChar(/[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(firstPassword));
            setMatch(firstPassword && firstPassword === secondPassword);
            if (firstPassword !== "") {
                document.getElementById("password-text-muted").className = "active";
                document.getElementById("match-text").className = "active";
            }
            else {
                document.getElementById("password-text-muted").className = "hide";
                document.getElementById("match-text").className = "hide";
            }

        }, [firstPassword, secondPassword]);

        localStorage.setItem("newPasswordValidation",
            validMinLength === true &&
            validMaxLength === true &&
            hasNumber === true &&
            upperCase === true &&
            lowerCase === true &&
            specialChar === true &&
            match === true
        )

        // setPasswordValidation(
        //     validMinLength === true &&
        //     validMaxLength === true &&
        //     hasNumber === true &&
        //     upperCase === true &&
        //     lowerCase === true &&
        //     specialChar === true &&
        //     match === true
        // )
        // localStorage.setItem("newPasswordValidation",
        //     validMinLength === true &&
        //     validMaxLength === true &&
        //     hasNumber === true &&
        //     upperCase === true &&
        //     lowerCase === true &&
        //     specialChar === true &&
        //     match === true
        // )

        return [validMinLength, validMaxLength, hasNumber, upperCase, lowerCase, match, specialChar];
    }

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const toggleConfirmPassword = () => {
        setConfirmPasswordShown(!confirmPasswordShown);
    };

    const [password, setPassword] = useState({
        firstPassword: "",
        secondPassword: "",
    });

    const [
        validMinLength,
        validMaxLength,
        hasNumber,
        upperCase,
        lowerCase,
        match,
        specialChar,
    ] = usePasswordValidation({
        firstPassword: password.firstPassword,
        secondPassword: password.secondPassword,
    });

    const setFirst = (event) => {
        setPassword({ ...password, firstPassword: event.target.value });
    };
    const setSecond = (event) => {
        setPassword({ ...password, secondPassword: event.target.value });
    };

    return (
        <>
            <Form.Group
                className="mb-3 password"
                controlId="formBasicPassword"
            >
                <Form.Label>{t("Password")} *</Form.Label>
                <Form.Control
                    required
                    type={ passwordShown ? "text" : "password"}
                    onChange={setFirst}
                    placeholder={t("Enter password")}
                    name="password"
                />
                <FeatherIcon icon={passwordShown ? "eye" : "eye-off"} onClick={togglePassword} />

                <div id='password-text-muted' className="hide">
                    <Form.Text className={`text-muted ${ validMinLength ? "accept" : "alarm"} `}>
                        <FeatherIcon icon={validMinLength ? "check-circle" : "alert-circle"} /> {t("At least 8 characters")}
                    </Form.Text>
                    <Form.Text className={`text-muted ${ lowerCase ? "accept" : "alarm"} `}>
                        <FeatherIcon icon={lowerCase ? "check-circle" : "alert-circle"} /> {t("Includes at least 1 lower case character")}
                    </Form.Text>

                    <Form.Text className={`text-muted ${ upperCase ? "accept" : "alarm"} `}>
                        <FeatherIcon icon={upperCase ? "check-circle" : "alert-circle"} /> {t("Includes at least 1 upper case character")}
                    </Form.Text>

                    <Form.Text className={`text-muted ${ specialChar ? "accept" : "alarm"} `}>
                        <FeatherIcon icon={specialChar ? "check-circle" : "alert-circle"} /> {t("Includes at least 1 special character")}
                    </Form.Text>

                    <Form.Text className={`text-muted ${ hasNumber ? "accept" : "alarm"} `}>
                        <FeatherIcon icon={hasNumber ? "check-circle" : "alert-circle"} /> {t("Includes at least 1 number")}
                    </Form.Text>
                    {!validMaxLength && (
                        <Form.Text className={`text-muted ${validMaxLength ? "accept" : "alarm"} `}>
                            <FeatherIcon
                                icon={validMaxLength ? "check-circle" : "alert-circle"}/> {t("Maximum 100 characters")}
                        </Form.Text>)
                    }
                </div>
            </Form.Group>

            <Form.Group className="mb-3 password" controlId="formConfirmBasicPassword">
                <Form.Label>{t("Confirm New Password")} *</Form.Label>
                <Form.Control
                    required
                    type={confirmPasswordShown ? "text" : "password"}
                    onChange={setSecond}
                    placeholder={t("Confirm new password")}
                    name="confirm_password"
                />
                <FeatherIcon icon={confirmPasswordShown ? "eye" : "eye-off"} onClick={toggleConfirmPassword} />
                <div id="match-text" className={ match ? "hide" : "active" }>

                    <Form.Text className={`text-muted alarm`}>
                        <FeatherIcon icon="alert-circle" /> {t("Confirm Password must be the same")}
                    </Form.Text>
                </div>
            </Form.Group>
        </>
    );
}


export default Password